import { realTimeApiInstance } from '../api';
import dayjs from 'dayjs';

export const fetchDailyAverageInitialState = async (
  assetId: string,
  startDate: Date,
  endDate: Date,
  aggregate: string,
  aggregateMethod: string,
  rodlift?: boolean,
) => {
  try {
    const headers: Record<string, string> = {};
    if (rodlift) {
      headers['x-api-version'] = '2.0';
    }

    const response = await realTimeApiInstance.get('RealTimeData/GetAssetTrendsGraphData', {
      params: {
        assetId,
        startDate: dayjs(startDate).format('YYYY-MM-DD HH:mm:ss.SSS'),
        endDate: dayjs(endDate).format('YYYY-MM-DD HH:mm:ss.SSS'),
        aggregate,
        aggregateMethod,
        ReteriveMixMax: true,
      },
      headers,
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching daily average data:', error);
    return [];
  }
};
